module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-46.cf136aa8.svg";